import { apiFetch } from '../../lib/api/client';
import type { PublicSite } from './types';

/** One request for the entire public site. */
export function fetchPublicSite(): Promise<PublicSite> {
  return apiFetch<PublicSite>('/api/v1/public/site');
}
